import DwellTimeManager from './DwellTimeManager';
import { generatePageId } from './DwellTimeUtil';
var DwellTimeRouteTracker = /** @class */ (function () {
    function DwellTimeRouteTracker() {
        this.currentPageId = null;
        this.previousPageId = null;
        this.unlisten = null;
        this.isInitialized = false;
    }
    DwellTimeRouteTracker.getInstance = function () {
        if (!DwellTimeRouteTracker.instance) {
            DwellTimeRouteTracker.instance = new DwellTimeRouteTracker();
        }
        return DwellTimeRouteTracker.instance;
    };
    DwellTimeRouteTracker.prototype.initialize = function () {
        var _this = this;
        if (this.isInitialized) {
            return;
        }
        var dwellManager = DwellTimeManager.getInstance();
        if (!dwellManager) {
            return;
        }
        dwellManager.setCurrentPageIdCallback(function () { return _this.currentPageId; });
        if (typeof window !== 'undefined') {
            try {
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                var browserHistory = require('react-router').browserHistory;
                if (browserHistory && typeof browserHistory.listen === 'function') {
                    this.unlisten = browserHistory.listen(function (location) {
                        _this.handleRouteChange(location);
                    });
                }
            }
            catch (e) {
                window.addEventListener('popstate', function () {
                    _this.handleRouteChange(window.location);
                });
            }
            this.handleRouteChange(window.location);
            setTimeout(function () {
                if (_this.currentPageId) {
                    dwellManager.logDwellTimeIfAvailable(_this.currentPageId);
                }
            }, 100);
        }
        this.isInitialized = true;
    };
    DwellTimeRouteTracker.prototype.cleanup = function () {
        if (this.unlisten) {
            this.unlisten();
            this.unlisten = null;
        }
        this.isInitialized = false;
    };
    DwellTimeRouteTracker.prototype.onRouteChange = function (prevRoute, nextRoute) {
        if (!nextRoute || !nextRoute.location) {
            return;
        }
        this.handleRouteChange(nextRoute.location);
    };
    DwellTimeRouteTracker.prototype.handleRouteChange = function (location) {
        var dwellManager = DwellTimeManager.getInstance();
        if (!dwellManager) {
            return;
        }
        var newPageId = generatePageId(location);
        if (!newPageId) {
            return;
        }
        if (newPageId !== this.currentPageId) {
            var isBackNavigation = dwellManager.isPageInDwellStack(newPageId);
            if (isBackNavigation) {
                dwellManager.checkAndTriggerDwellTimeFDP(newPageId);
            }
            else if (this.currentPageId) {
                var pageType = this.extractPageTypeFromPath(location);
                dwellManager.addDwellObject(newPageId, undefined, undefined, undefined, pageType);
            }
            else {
                var pageType = this.extractPageTypeFromPath(location);
                dwellManager.addDwellObject(newPageId, undefined, undefined, undefined, pageType);
            }
            this.previousPageId = this.currentPageId;
            this.currentPageId = newPageId;
            setTimeout(function () {
                dwellManager.logDwellTimeIfAvailable(newPageId);
            }, 100);
        }
    };
    DwellTimeRouteTracker.prototype.extractPageTypeFromPath = function (location) {
        if (!location || !location.pathname) {
            return undefined;
        }
        var pathname = location.pathname || '';
        var pagePath = pathname.replace(/^\/(en|hi|ta|te|kn|ml|mr|gu|pa|bn|as|or)\//, '/');
        if (pagePath.startsWith('/rv/')) {
            var parts = pagePath.split('/').filter(function (p) { return p; });
            if (parts.length >= 2) {
                var pageName = parts[1];
                var pageType = pageName.charAt(0).toUpperCase() + pageName.slice(1);
                return "RV-" + pageType;
            }
        }
        return undefined;
    };
    DwellTimeRouteTracker.prototype.getCurrentPageId = function () {
        return this.currentPageId;
    };
    DwellTimeRouteTracker.prototype.checkCurrentPageDwellTime = function () {
        var dwellManager = DwellTimeManager.getInstance();
        if (dwellManager && this.currentPageId) {
            dwellManager.checkAndTriggerDwellTimeFDP(this.currentPageId);
        }
    };
    return DwellTimeRouteTracker;
}());
export default DwellTimeRouteTracker.getInstance();
